import { render, staticRenderFns } from "./CustomerContactView.vue?vue&type=template&id=d5036760"
import script from "./CustomerContactView.vue?vue&type=script&lang=js"
export * from "./CustomerContactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports